import { useQuery } from "react-query";

import type { GetPendingTreatmentActivityLogsArgs } from "api/services/admin/schemas/activity_log";
import { useApiClient } from "api/useApiClient";

const getPendingTreatmentActivityLogsQueryKey = (args: GetPendingTreatmentActivityLogsArgs) =>
  ["getPendingTreatmentActivityLogs", args.health_care_organization_id, args.params] as const;

export const useGetPendingTreatmentActivityLogs = (args: GetPendingTreatmentActivityLogsArgs) => {
  const client = useApiClient();

  return useQuery(getPendingTreatmentActivityLogsQueryKey(args), () => client.getPendingTreatmentActivityLogs(args), {
    keepPreviousData: true,
  });
};
